import React, { useEffect, useState, useCallback } from 'react'
import Container from '../Container/Container';
import { useNavigate } from 'react-router-dom';
import Loader from '../Pages/Component/Loader';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { get, ImageUrl } from '../ApiServices/ApiServices';
import { Image } from 'antd';
import moment from "moment";
import { useSelector } from 'react-redux';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

function Dashboard() {
   const [AccOverview, setAccOverview] = useState([])
   const [loading, setLoading] = useState(false);
   const [recentOrdersLoading, setRecentOrdersLoading] = useState(false); // New loader state for recent orders
   const [ActiveOrder, setActiveOrder] = useState([])
   const [ActivRental, setActiveRental] = useState([])
   const [RecentOrders, setRecentOrders] = useState([])
   const [Orderview, setOrderview] = useState([])
   const navigate = useNavigate();
   const [inventoryRatings, setInventoryRatings] = useState([]);
   const [itemsPerPage, setItemsPerPage] = useState(10);
   const [totalItems, setTotalItems] = useState(40);
   const [currentPage, setCurrentPage] = useState(1);
   const [RentalCurrentPage, setRentalCurrentPage] = useState(1);
   const [totalRentalItems, setTotalRentalItems] = useState(0);
   const [MonthlyComp, setMonthlyComp] = useState([])
   const [SalesPerf, setSalesPerf] = useState([])
   const [MonthlyComparisonNew, setMonthlyComparisonNew] = useState([])
   const [TopCoat, setTopCoat] = useState([])
   const [orderStatusFilter, setOrderStatusFilter] = useState('');
   const [displayLabel, setDisplayLabel] = useState('');
   const [Status, setStatus] = useState([])

   const [searchTerm, setSearchTerm] = useState('');
   const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

   const profile = useSelector((state) => state.profile.profile);
   const userAccount = useSelector((state) => state.profile.profile?.account);
   const isAdmin = profile?.name === "Admin";
   console.log(userAccount, "userAccount");


   const [dateRange, setDateRange] = useState({
      startDate: "",
      endDate: "",
   });



   const ActiveStatus = async () => {
      try {
         setLoading(true)
         const api = `get-statuses`;
         const response = await get(api);
         if (response?.message === "success") {
            setStatus(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   useEffect(() => {
      ActiveStatus()
   }, [])

   const handleSearch = (e) => {
      const value = e.target.value;
      setSearchTerm(value);
      handleSearchDebounced(value);
   };

   const handleOrderStatusChange = (e) => {
      setOrderStatusFilter(e.target.value);
      setCurrentPage(1);
   };

   const orderStatuses = [
      { value: '', label: 'All Statuses' },
      { value: 'ordered', label: 'Ordered' },
      { value: 'changed', label: 'Changed' },
      { value: 'bagged', label: 'Bagged' },
      { value: 'shipped', label: 'Shipped' },
      { value: 'delivered', label: 'Delivered' }
   ];
   const debounce = (func, delay) => {
      let timer;
      return function (...args) {
         clearTimeout(timer);
         timer = setTimeout(() => func.apply(this, args), delay);
      };
   };


   const onDateChange = (dates) => {
      if (dates.startDate && dates.endDate) {
         setDateRange({
            startDate: dates.startDate,
            endDate: dates.endDate
         });
      } else {
         setDateRange({
            startDate: null,
            endDate: null
         });
      }
      setCurrentPage(1);
   };


   const handleApply = (event, picker) => {
      const startDate = picker.startDate;
      const endDate = picker.endDate;

      setDateRange({ startDate, endDate });
      setDisplayLabel(`${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`);

      if (onDateChange) {
         onDateChange({
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD')
         });
      }
   };

   const handleCancel = (event, picker) => {
      setDateRange({
         startDate: null,
         endDate: null,
      });
      setDisplayLabel('');
      setDateRange({
         startDate: null,
         endDate: null
      });

      if (picker) {
         picker.setStartDate(moment());
         picker.setEndDate(moment());
         picker.updateView();
      }
   };

   const handleSearchDebounced = useCallback(
      debounce((value) => {
         setDebouncedSearchTerm(value);
         setCurrentPage(1);
      }, 500),
      []
   );
   // Mock data for testing
   // const MonthlyComparisonNew = [
   //    {
   //       "2023": 19,
   //       "2024": 12,
   //       "2025": 14,
   //       "category": "Wedding"
   //    },
   //    {
   //       "2023": 10,
   //       "2024": 19,
   //       "2025": 9,
   //       "category": "Single"
   //    },
   //    {
   //       "2023": 12,
   //       "2024": 7,
   //       "2025": 10,
   //       "category": "Prom"
   //    }
   // ]
   // New API call for the monthly comparison data
   const MonthlyComparisonNewAPI = async () => {
      try {
         const api = `monthly-comparison-new`;
         const response = await get(api);
         if (response?.status == true) {
            setMonthlyComparisonNew(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      }
   };

   // Function to transform the new API data to chart format
   const transformChartData = (apiData) => {
      if (!apiData || apiData.length === 0) return [];

      // Create an array for each year with all three categories
      const years = ['2023', '2024', '2025'];

      const formattedData = years.map(year => {
         const yearData = { name: year };

         // For each category, get the value for this year
         apiData.forEach(item => {
            const category = item.category?.toLowerCase();
            if (category && item[year] !== undefined) {
               yearData[category] = item[year] || 0;
            }
         });

         return yearData;
      });

      return formattedData;
   };

   // Calculate Y-axis settings for the new chart
   const calculateYAxis = (data) => {
      if (!data || data.length === 0) {
         return { max: 20, ticks: [0, 5, 10, 15, 20] };
      }

      // Get all values from all categories
      const allValues = data.flatMap(item => [
         item.wedding || 0,
         item.single || 0,
         item.prom || 0
      ]);

      const maxValue = Math.max(...allValues);
      const roundedMax = Math.ceil(maxValue / 5) * 5;
      const finalMax = roundedMax === 0 ? 20 : roundedMax;

      const tickCount = 5;
      const tickStep = finalMax / (tickCount - 1);
      const ticks = Array.from({ length: tickCount }, (_, i) => Math.round(i * tickStep));

      return { max: finalMax, ticks };
   };

   // Prepare data for the new chart
   const newChartData = transformChartData(MonthlyComparisonNew);
   const { max: newYAxisMax, ticks: newYAxisTicks } = calculateYAxis(newChartData);

   const SalesPerformance = async () => {
      try {
         const api = `sales-performance`;
         const response = await get(api);
         if (response?.status == true) {
            setSalesPerf(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const prepareChartData = () => {
      return SalesPerf.map(item => ({
         name: item.category,
         current: item.current,
         previous: item.previous,
         prom: item.previous
      }));
   };

   const calculateYAxisScale = (data) => {
      if (data.length == 0) return { ticks: [0, 20, 40, 60, 80], max: 80 };
      const maxValue = Math.max(...data.flatMap(item => [item.current, item.previous, item.prom || 0]));
      let increment = 10;
      if (maxValue > 100) increment = 20;
      if (maxValue > 500) increment = 50;
      if (maxValue > 1000) increment = 100;

      const roundedMax = Math.ceil(maxValue / increment) * increment + increment;
      const ticks = [];
      for (let i = 0; i <= roundedMax; i += increment) {
         ticks.push(i);
      }

      return { ticks, max: roundedMax };
   };

   const SaleschartData = prepareChartData();
   const { ticks: yTicks, max: yMax } = calculateYAxisScale(SaleschartData);

   const OrderOverwiew = async () => {
      try {
         const api = `orders-overview`;
         const response = await get(api);
         setOrderview(response?.data)
         if (response?.status == true) {
            setOrderview(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const prepareOverviewChartData = () => {
      return Orderview.map(item => ({
         name: item.month,
         currentOverview: item.currentYearCount,
         previousOverview: item.previousYearCount
      }));
   };

   const calculateOverviewYAxisScale = (data) => {
      if (data.length === 0) return { overviewTicks: [0, 100, 200, 300, 400], overviewMax: 400 };

      const overviewMaxValue = Math.max(...data.flatMap(item => [item.currentOverview, item.previousOverview]));

      let increment = 50;
      if (overviewMaxValue > 500) increment = 100;
      if (overviewMaxValue > 1000) increment = 200;

      const overviewRoundedMax = Math.ceil(overviewMaxValue / increment) * increment + increment;

      const overviewTicks = [];
      for (let i = 0; i <= overviewRoundedMax; i += increment) {
         overviewTicks.push(i);
      }

      return { overviewTicks, overviewMax: overviewRoundedMax };
   };

   const overviewChartData = prepareOverviewChartData();
   const { overviewTicks, overviewMax } = calculateOverviewYAxisScale(overviewChartData);

   const MonthlyComparison = async () => {
      try {
         const api = `monthly-comparison`;
         const response = await get(api);
         if (response?.status == true) {
            setMonthlyComp(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };







   const prepareMonthlyChartData = () => {
      return MonthlyComp.map(item => ({
         name: item.category,
         current: item.current,
         previous: item.previous
      }));
   };

   const calculateMonthlyYAxisScale = (data) => {
      if (data.length === 0) return { yAxisTicks: [0, 20, 40, 60, 80], yAxisMax: 80 };

      const maxValue = Math.max(...data.flatMap(item => [item.current, item.previous]));

      let increment = 10;
      if (maxValue > 100) increment = 20;
      if (maxValue > 500) increment = 50;
      if (maxValue > 1000) increment = 100;
      if (maxValue > 5000) increment = 500;

      const roundedMax = Math.ceil(maxValue / increment) * increment + increment;

      const yAxisTicks = [];
      for (let i = 0; i <= roundedMax; i += increment) {
         yAxisTicks.push(i);
      }

      return { yAxisTicks, yAxisMax: roundedMax };
   };

   const chartData = prepareMonthlyChartData();
   const { yAxisTicks, yAxisMax } = calculateMonthlyYAxisScale(chartData);

   const AccountOverview = async () => {
      try {
         const api = `account-overview`;
         const response = await get(api);
         if (response?.status == true) {
            setAccOverview(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const ActiveOrders = async () => {
      try {
         const api = `active-orders`;
         const response = await get(api);
         setActiveOrder(response?.total);
         if (response?.message === "success") {
            setActiveOrder(response?.data);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   const ActiveRental = async (pageactive) => {
      try {
         setLoading(true)
         const api = `active-rentals?page_number=${pageactive}`;
         const response = await get(api);
         if (response?.status) {
            setLoading(false)
            setActiveRental(response?.data?.rows);
            setTotalRentalItems(response?.data?.count);
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      }
   };

   const fetchInventoryRatings = async (page) => {
      try {
         const response = await get(`inventories-ratings?page_number=${page}`);
         if (response?.status && response?.data?.rows) {
            setInventoryRatings(response?.data?.rows);
            setTotalItems(response?.data?.count)
         }
      } catch (error) {
         console.error('Error fetching inventory ratings:', error);
      }
   };

   useEffect(() => {
      ActiveOrders();
      fetchInventoryRatings();
      ActiveRental()
      AccountOverview()
      MonthlyComparison()
      SalesPerformance()
      OrderOverwiew()
      MonthlyComparisonNewAPI()
   }, []);

   useEffect(() => {
      fetchInventoryRatings(currentPage);
   }, [currentPage]);

   useEffect(() => {
      ActiveRental(RentalCurrentPage)
   }, [RentalCurrentPage]);

   const handlePageChange = (page) => setCurrentPage(page);
   const totalPages = Math.ceil(totalItems / itemsPerPage);

   const now = new Date();
   const monthYear = now.toLocaleString('default', { month: 'long', year: 'numeric' });

   const RecentOrder = async () => {
      try {
         setRecentOrdersLoading(true); // Use specific loader for recent orders
         let api = `recent-orders?search=${debouncedSearchTerm || ""}`;

         if (dateRange?.startDate && moment(dateRange.startDate).isValid()) {
            api += `&start_date=${moment(dateRange.startDate).format('YYYY-MM-DD')}`;
         }

         if (dateRange?.endDate && moment(dateRange.endDate).isValid()) {
            api += `&end_date=${moment(dateRange.endDate).format('YYYY-MM-DD')}`;
         }

         if (orderStatusFilter) {
            api += `&order_status=${orderStatusFilter}`;
         }

         const response = await get(api);
         if (response?.status == true) {
            if (isAdmin) {
               setRecentOrders(response?.data?.rows)
            }
            else {
               const userOrders = response?.data?.rows?.filter(order =>
                  order?.account === userAccount
               );
               setRecentOrders(userOrders || []);
            }
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
         setRecentOrdersLoading(false); // Turn off specific loader
      }
   };

   useEffect(() => {
      RecentOrder();
      TopCoatRental()
   }, [debouncedSearchTerm, dateRange, orderStatusFilter])


   useEffect(() => {
      TopCoatRental()
   }, [])

   const TopCoatRental = async () => {
      try {
         const api = `top-five-inventories`;
         const response = await get(api);
         if (response?.status == true) {
            setTopCoat(response?.data)
         }
      } catch (err) {
         console.error('Error:', err);
         if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
            localStorage.removeItem('token');
            navigate('/login');
         }
      } finally {
      }
   };

   return (
      <>
         <Container>
            <div className="nk-content">
               <div className="container-fluid">
                  <div className="nk-content-inner">
                     {loading ?
                        <Loader />
                        :
                        <>
                           <div className="nk-content-body">
                              <div className="nk-block-head nk-block-head-sm pbZeroHeadin">
                                 <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                       <h3 className="nk-block-title page-title">Dashboard </h3>
                                    </div>
                                    <div className="nk-block-head-content">
                                       <div className="toggle-wrap nk-block-tools-toggle">
                                          <div className="toggle-expand-content" data-content="pageMenu">
                                             <ul className="nk-block-tools g-3">
                                                <li className="nk-block-tools-opt">
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="card card-preview">
                                 <div className="card-inner">
                                    <h5 className="mb-3">Top Metrics for Active Orders</h5>
                                    <div className="row g-gs">
                                       {/* Your metric cards remain the same */}
                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_count ?? "N/A"}</h6>
                                                   <p>Total Active Orders</p>
                                                </div>
                                                <span><img src="assets/images/d1.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.total_count_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.total_count_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.total_count_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>

                                       {/* Add other metric cards here */}


                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_wedding_order_count ?? "N/A"}</h6>
                                                   <p>Wedding Orders</p>
                                                </div>
                                                <span><img src="assets/images/d5.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.wedding_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.wedding_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.wedding_order_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_single_order_count ?? "N/A"}</h6>
                                                   <p>Single Orders</p>
                                                </div>
                                                <span><img src="assets/images/d4.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.single_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.single_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.single_order_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_prom_order_count ?? "N/A"}</h6>
                                                   <p>Prom Orders</p>
                                                </div>
                                                <span><img src="assets/images/d6.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.prom_order_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.prom_order_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.prom_order_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_count_for_ship_prep ?? "N/A"}</h6>
                                                   <p>Orders Prepared To Ship</p>
                                                </div>
                                                <span><img src="assets/images/d3.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.ship_prep_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.ship_prep_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.ship_prep_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_shipped_this_week_count ?? "N/A"}</h6>
                                                   <p>Orders Shipped This Week</p>
                                                </div>
                                                <span><img src="assets/images/d2.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.shipped_this_week_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.shipped_this_week_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.shipped_this_week_change?.value ?? 0}%
                                                </span>
                                                <small>Since last month</small>
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_return_due_count ?? "N/A"}</h6>
                                                   <p>Orders Due For Return This Week</p>
                                                </div>
                                                <span><img src="assets/images/d8.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.return_due_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.return_due_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.return_due_change?.value ?? 0}%
                                                </span>
                                             </div>
                                          </div>
                                       </div>

                                       <div className="col-xxl-3 col-sm-3">
                                          <div className="cardBoxOrder">
                                             <div className="cardBoxOrdersInner">
                                                <div className="leftCOrder">
                                                   <h6>{ActiveOrder?.total_delinquent_count ?? "N/A"}</h6>
                                                   <p>Delinquent Orders </p>
                                                </div>
                                                <span><img src="assets/images/d7.svg" alt="" /></span>
                                             </div>
                                             <div className="infUpDown">
                                                <span className={ActiveOrder?.delinquent_change?.direction === 'increase' ? '' : 'redDown'}>
                                                   <em className={`icon ni ni-arrow-long-${ActiveOrder?.delinquent_change?.direction === 'increase' ? 'up' : 'down'} `}></em>
                                                   {ActiveOrder?.delinquent_change?.value ?? 0}%
                                                </span>
                                             </div>
                                          </div>
                                       </div>
                                    </div>

                                    {/* NEW CHART WITH THREE BARS */}
                                    <div className="row g-gs mt-2">
                                       <div className="col-lg-7 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title">
                                                   <h6 className="title">Current Month vs. Same Month Last Year</h6>
                                                </div>
                                             </div>
                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{ height: '300px', width: "100%" }}>
                                                      <ResponsiveContainer width="100%" height="100%">
                                                         <BarChart
                                                            data={newChartData}
                                                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                                            barGap={10}
                                                            barCategoryGap={20}
                                                         >
                                                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                            <XAxis
                                                               dataKey="name"
                                                               axisLine={false}
                                                               tickLine={false}
                                                            />
                                                            <YAxis
                                                               axisLine={false}
                                                               tickLine={false}
                                                               ticks={newYAxisTicks}
                                                               domain={[0, newYAxisMax]}
                                                            />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar
                                                               dataKey="wedding"
                                                               name="Wedding"
                                                               fill="#009299"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="single"
                                                               name="Single"
                                                               fill="#003f72"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="prom"
                                                               name="Prom"
                                                               fill="#7ed956"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                         </BarChart>
                                                      </ResponsiveContainer>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-lg-5 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title">
                                                   <h6 className="title">Top 5 Rental Coats</h6>
                                                </div>
                                             </div>
                                             <ul className="nk-top-products">
                                                {TopCoat.map((data, index) => (
                                                   <li key={index} className="item">
                                                      <div className="thumb">
                                                         <Image src={data?.image ? `${ImageUrl}${data?.image} ` : "assets/images/no-photo.png"} alt="" height={50} width={0} />
                                                      </div>
                                                      <div className="info">
                                                         <div className="title">{data?.description}({data?.inventory_id})</div>
                                                         <div className="price">{data?.coat_only_retail ? data?.coat_only_retail : "N/A"}</div>
                                                      </div>
                                                   </li>
                                                ))}
                                             </ul>
                                          </div>
                                       </div>
                                    </div>

                                    {/* OTHER CHARTS */}
                                    <div className="row g-gs mt-2">
                                       <div className="col-md-7 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title"><h6 className="title">Sales Performance</h6></div>
                                                <div className="card-tools">
                                                   <div className="selectBoxMonth">
                                                      <select><option>Last Month</option></select>
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{ height: '300px', width: "100%" }}>
                                                      <ResponsiveContainer width="100%" height="100%">
                                                         <BarChart
                                                            data={SaleschartData}
                                                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                                            barGap={10}
                                                            barCategoryGap={20}
                                                         >
                                                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                            <XAxis
                                                               dataKey="name"
                                                               axisLine={false}
                                                               tickLine={false}
                                                            />
                                                            <YAxis
                                                               axisLine={false}
                                                               tickLine={false}
                                                               domain={[0, yMax]}
                                                            />
                                                            <Tooltip />
                                                            <Legend />
                                                            <Bar
                                                               dataKey="current"
                                                               name="Wedding"
                                                               fill="#21A085"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="previous"
                                                               name="Single"
                                                               fill="#3A7CA5"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                            <Bar
                                                               dataKey="prom"
                                                               name="Prom"
                                                               fill="#C5EBE5"
                                                               radius={[4, 4, 0, 0]}
                                                            />
                                                         </BarChart>
                                                      </ResponsiveContainer>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div className="col-md-5 d-flex align-items-stretch">
                                          <div className="chartBoxDashNew w-100">
                                             <div className="card-title-group mb-2">
                                                <div className="card-title"><h6 className="title">Orders Overview</h6></div>
                                                <div className="card-tools">
                                                   <div className="selectBoxMonth">
                                                      <small><a href=""><em className="icon ni ni-download-cloud"></em> Download overall report</a></small>
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="chartBoxHere mt-2">
                                                <div className="chartBgShape">
                                                   <div style={{
                                                      height: '300px',
                                                      width: "100%",
                                                      overflowX: 'auto',
                                                      overflowY: 'hidden'
                                                   }}>
                                                      <div style={{ height: '300px', width: "100%" }}>
                                                         <ResponsiveContainer width="100%" height="100%">
                                                            <BarChart
                                                               data={overviewChartData}
                                                               margin={{ top: 0, right: 0, left: 0, bottom: 5 }}
                                                               barGap={10}
                                                               barCategoryGap={20}
                                                            >
                                                               <CartesianGrid strokeDasharray="3 3" vertical={false} />
                                                               <XAxis
                                                                  dataKey="name"
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  tick={{ angle: -45, textAnchor: 'end', fontSize: 10 }}
                                                                  interval={0}
                                                               />
                                                               <YAxis
                                                                  axisLine={false}
                                                                  tickLine={false}
                                                                  ticks={overviewTicks}
                                                                  domain={[0, overviewMax]}
                                                               />
                                                               <Tooltip />
                                                               <Legend />
                                                               <Bar
                                                                  dataKey="currentOverview"
                                                                  name="This year"
                                                                  fill="#F1CAC6"
                                                                  barSize={12}
                                                               />
                                                               <Bar
                                                                  dataKey="previousOverview"
                                                                  name="Previous year"
                                                                  fill="#A4C3D2"
                                                                  barSize={12}
                                                               />
                                                            </BarChart>
                                                         </ResponsiveContainer>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>

                                    <div className="row g-gs mt-2">
                                       <div className="col-md-12 priceList">
                                          <div className="mResponsive">
                                             <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                   <a className="nav-link active" data-bs-toggle="tab" href="#tabItem1">Recent Orders</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem2">Account Overview</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem3">Active Rentals</a>
                                                </li>
                                                <li className="nav-item">
                                                   <a className="nav-link" data-bs-toggle="tab" href="#tabItem4">Most Rented Styles Report</a>
                                                </li>
                                             </ul>
                                          </div>
                                          <div className="tab-content">
                                             <div className="tab-pane active" id="tabItem1">
                                                <div className="row align-items-center justify-content-between">
                                                   <div className="col-md-6">
                                                      <h5>Recent Orders</h5>
                                                   </div>
                                                </div>
                                                <div className="card-title-group mb-3">
                                                   <div className="card-tools" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                                                      <div className="form-control-wrap">
                                                         <div className="form-icon form-icon-right">
                                                            <em className="icon ni ni-search"></em>
                                                         </div>
                                                         <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search by Account# or Order#"
                                                            value={searchTerm}
                                                            onChange={handleSearch}
                                                            disabled={recentOrdersLoading}
                                                            style={{ minWidth: '250px' }}
                                                         />
                                                      </div>

                                                      <div className="form-control-wrap">
                                                         <select
                                                            className="form-control"
                                                            value={orderStatusFilter}
                                                            onChange={handleOrderStatusChange}
                                                            disabled={recentOrdersLoading}
                                                            style={{ minWidth: '200px' }}
                                                         >
                                                            <option value="">Filter by Active Status</option>
                                                            <option value="">All</option>
                                                            {
                                                               Status?.map((data) => (
                                                                  <option key={data.name} value={data.name}>
                                                                     {data?.name}
                                                                  </option>
                                                               ))
                                                            }
                                                         </select>
                                                      </div>

                                                      <div className="form-control-wrap">
                                                         <DateRangePicker
                                                            initialSettings={{
                                                               startDate: dateRange.startDate || moment(),
                                                               endDate: dateRange.endDate || moment(),
                                                               locale: {
                                                                  format: 'MMM D, YYYY',
                                                                  cancelLabel: 'Clear',
                                                                  applyLabel: 'Apply',
                                                               },
                                                               ranges: {
                                                                  'Today': [moment(), moment()],
                                                                  'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                                  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                                  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                                  'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                               },
                                                               opens: 'right',
                                                               autoApply: true,
                                                               autoUpdateInput: true,
                                                               alwaysShowCalendars: true,
                                                               showCustomRangeLabel: true,
                                                               showCancel: true,
                                                            }}
                                                            onApply={handleApply}
                                                            onCancel={handleCancel}
                                                         >
                                                            <input
                                                               type="text"
                                                               className="form-control"
                                                               placeholder="Select Weekend date range"
                                                               value={displayLabel}
                                                               readOnly
                                                               style={{
                                                                  cursor: 'pointer',
                                                                  backgroundColor: '#fff',
                                                                  border: '1px solid #dbdfea',
                                                                  borderRadius: '4px',
                                                                  padding: '0.375rem 0.75rem',
                                                                  minWidth: '250px',
                                                                  paddingRight: '30px',
                                                                  color: '#35495e',
                                                               }}
                                                            />
                                                         </DateRangePicker>
                                                         {displayLabel && (
                                                            <span
                                                               className="clear-icon"
                                                               onClick={(e) => {
                                                                  e.stopPropagation();
                                                                  e.preventDefault();
                                                                  const cancelBtn = document.querySelector('.daterangepicker .cancelBtn');
                                                                  if (cancelBtn) {
                                                                     cancelBtn.click();
                                                                  } else {
                                                                     handleCancel();
                                                                  }
                                                               }}
                                                               style={{
                                                                  position: 'absolute',
                                                                  right: '10px',
                                                                  top: '50%',
                                                                  transform: 'translateY(-50%)',
                                                                  cursor: 'pointer',
                                                                  zIndex: 10
                                                               }}
                                                            >
                                                               <em className="icon ni ni-cross"></em>
                                                            </span>
                                                         )}
                                                      </div>
                                                   </div>
                                                </div>
                                                <div className="row mt-3">
                                                   <div className="col-md-12">
                                                      {recentOrdersLoading ? (
                                                         <div className="text-center py-4">

                                                            <Loader />                                                         </div>
                                                      ) : (
                                                         <div className="table-responsive">
                                                            <table className="table table-striped">
                                                               <thead>
                                                                  <tr>
                                                                     <th scope="col">Account #</th>
                                                                     <th scope="col">Order # </th>
                                                                     <th scope="col">Type</th>
                                                                     <th scope="col">Style Photo</th>
                                                                     <th scope="col">Style Name</th>
                                                                     <th scope="col">Order Date</th>
                                                                     <th scope="col">Customer Name</th>
                                                                     <th scope="col">Event Date</th>
                                                                     <th scope="col">Week Ending Date</th>

                                                                     <th scope="col">Order Status</th>
                                                                     <th scope="col">Action</th>
                                                                  </tr>
                                                               </thead>
                                                               <tbody>
                                                                  {RecentOrders && RecentOrders.length > 0 ? (
                                                                     RecentOrders.map((data) => (
                                                                        <tr key={data?.order_id}>
                                                                           <td className="tableMinWidth120" scope="row">{data?.account}</td>
                                                                           <td className="tableMinWidth120" scope="row">{data?.ticket}</td>
                                                                           <td className="tableMinWidth120" scope="row">{data?.order_type}</td>
                                                                           <td className="tableMinWidth120">
                                                                              <Image
                                                                                 src={data?.item_photo ? `${ImageUrl}${data?.item_photo}` : "assets/images/no-photo.png"}
                                                                                 alt=""
                                                                                 height={50}
                                                                                 width={40}
                                                                              />
                                                                           </td>
                                                                           <td className="tableMinWidth1550">{data?.product_name} {data?.product_description}</td>
                                                                           <td className="tableMinWidth120"> {data?.is_csv ? moment.utc(data?.order_creation).format("MMM D, YYYY") : moment.utc(data?.order_date).format("MMM D, YYYY")}</td>
                                                                           <td className="tableMinWidth1550">{data?.customer_name}</td>
                                                                           <td className="tableMinWidth120">{moment.utc(data?.event_date).format("MMM D, YYYY")}</td>
                                                                           <td>
                                                                              {(() => {
                                                                                 const eventDate = moment.utc(data?.event_date);
                                                                                 const currentDay = eventDate.isoWeekday(); // 1=Mon ... 7=Sun

                                                                                 if (currentDay === 7) return eventDate.clone().subtract(1, "day").format("MMM D, YYYY"); // Sunday → Previous Saturday
                                                                                 if (currentDay === 1) return eventDate.clone().subtract(2, "days").format("MMM D, YYYY"); // Monday → Previous Saturday
                                                                                 if (currentDay === 6) return eventDate.format("MMM D, YYYY"); // Saturday → Current
                                                                                 return eventDate.clone().isoWeekday(6).format("MMM D, YYYY"); // Tue–Fri → Upcoming Saturday
                                                                              })()}
                                                                           </td>
                                                                           <td className="tableMinWidth120">
                                                                              <span className="badge openBadge text-capitalize font-revert bg-warning">
                                                                                 {data?.order_status}
                                                                              </span>
                                                                           </td>
                                                                           <td>
                                                                              <div className="tableActionBtn-1" style={{ cursor: "pointer" }}>
                                                                                 <button
                                                                                    className="editPen"
                                                                                    onClick={() => {
                                                                                       if (data?.order_type === "Single Order") {
                                                                                          navigate('/order-detail', { state: { orderId: data?.order_id } });
                                                                                       } else {
                                                                                          navigate('/Member-detail', { state: { eventId: data?.order_id } });
                                                                                       }
                                                                                    }}
                                                                                 >
                                                                                    <em className="icon ni ni-eye"></em>
                                                                                 </button>
                                                                              </div>
                                                                           </td>
                                                                        </tr>
                                                                     ))
                                                                  ) : (
                                                                     <tr>
                                                                        <td colSpan="11" className="text-center py-3">
                                                                           No data available
                                                                        </td>
                                                                     </tr>
                                                                  )}
                                                               </tbody>

                                                            </table>
                                                         </div>
                                                      )}
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="tab-pane" id="tabItem2">
                                                <div className="row align-items-center justify-content-between">
                                                   <div className="col-md-6">
                                                      <h5>Account Overview</h5>
                                                   </div>
                                                </div>
                                                <div className="row mt-3">
                                                   <div className="col-md-12">
                                                      <div className="table-responsive">
                                                         <table className="table table-striped">
                                                            <thead>
                                                               <tr>
                                                                  <th scope="col">Month/Year</th>
                                                                  <th scope="col">Order Type</th>
                                                                  <th scope="col">Current Month Rentals</th>
                                                                  <th scope="col">Previous Month Rentals</th>
                                                                  <th scope="col">% Change from Prev Month</th>
                                                                  <th scope="col">Same Month Last Year Rentals</th>
                                                                  <th scope="col">% Change YoY</th>
                                                                  <th scope="col">YTD Rentals</th>
                                                                  <th scope="col">Previous YTD Rentals</th>
                                                                  <th scope="col">% YTD Change</th>
                                                               </tr>
                                                            </thead>
                                                            <tbody>
                                                               <tr>
                                                                  <th className="tableMinWidth120" scope="row">{monthYear}</th>
                                                                  <td className="tableMinWidth120">Wedding</td>
                                                                  <td className="tableMinWidth1550">{AccOverview?.wedding_order_current_month || 0}</td>
                                                                  <td className="tableMinWidth1550">{AccOverview?.wedding_order_previous_month || 0}</td>
                                                                  <td className="tableMinWidth1550">{AccOverview?.wedding_order_per_change_from_prev_month || 0}%</td>
                                                                  <td className="tableMinWidth1550">{AccOverview?.wedding_order_same_month_last_year || 0}</td>
                                                                  <td className="tableMinWidth120">{AccOverview?.wedding_order_per_change_yoy || 0}%</td>
                                                                  <td className="tableMinWidth120">{AccOverview?.wedding_order_ytd_rentals || 0}</td>
                                                                  <td className="tableMinWidth120">{AccOverview?.wedding_order_previous_ytd_rentals || 0}</td>
                                                                  <td className="tableMinWidth120">{AccOverview?.wedding_order_ytd_per_change || 0}%</td>
                                                               </tr>
                                                               <tr>
                                                                  <th scope="row">{monthYear}</th>
                                                                  <td>Single</td>
                                                                  <td>{AccOverview?.single_order_current_month || 0}</td>
                                                                  <td>{AccOverview?.single_order_previous_month || 0}</td>
                                                                  <td>{AccOverview?.single_order_per_change_from_prev_month || 0}%</td>
                                                                  <td>{AccOverview?.single_order_same_month_last_year || 0}</td>
                                                                  <td>{AccOverview?.single_order_per_change_yoy || 0}%</td>
                                                                  <td>{AccOverview?.single_order_ytd_rentals || 0}</td>
                                                                  <td>{AccOverview?.single_order_previous_ytd_rentals || 0}</td>
                                                                  <td>{AccOverview?.single_order_ytd_per_change || 0}%</td>
                                                               </tr>
                                                               <tr>
                                                                  <th scope="row">{monthYear}</th>
                                                                  <td>Prom</td>
                                                                  <td>{AccOverview?.prom_order_current_month || 0}</td>
                                                                  <td>{AccOverview?.prom_order_previous_month || 0}</td>
                                                                  <td>{AccOverview?.prom_order_per_change_from_prev_month || 0}%</td>
                                                                  <td>{AccOverview?.prom_order_same_month_last_year || 0}</td>
                                                                  <td>{AccOverview?.prom_order_per_change_yoy || 0}%</td>
                                                                  <td>{AccOverview?.prom_order_ytd_rentals || 0}</td>
                                                                  <td>{AccOverview?.prom_order_previous_ytd_rentals || 0}</td>
                                                                  <td>{AccOverview?.prom_order_ytd_per_change || 0}%</td>
                                                               </tr>
                                                            </tbody>
                                                         </table>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="tab-pane" id="tabItem3">
                                                <div className="row align-items-center justify-content-between">
                                                   <div className="col-md-6">
                                                      <h5>Active Rentals</h5>
                                                   </div>
                                                </div>
                                                <div className="row mt-3">
                                                   <div className="col-md-12">
                                                      <div className="table-responsive">
                                                         <table className="table table-striped">
                                                            <thead>
                                                               <tr>
                                                                  <th scope="col">Order #</th>
                                                                  <th scope="col">Customer Name</th>
                                                                  <th scope="col">Order Type</th>
                                                                  <th scope="col">Event Date</th>
                                                                  <th scope="col">Status</th>
                                                               </tr>
                                                            </thead>
                                                            <tbody>
                                                               {ActivRental && ActivRental.length > 0 ? (
                                                                  ActivRental.map((data) => (
                                                                     <tr key={data?.ticket || Math.random()}>
                                                                        <th scope="row">{data?.ticket || 'N/A'}</th>
                                                                        <td>
                                                                           {data?.user?.firstName ? `${data?.user?.firstName} ${data?.user?.lastName || ''} ` : 'N/A'}
                                                                        </td>
                                                                        <td>{data?.event_type || 'N/A'}</td>
                                                                        <td>{data?.current_event_date || 'N/A'}</td>
                                                                        <td>
                                                                           <span className="badge bg-outline-success">
                                                                              {data?.current_order_status_name || 'N/A'}
                                                                           </span>
                                                                        </td>
                                                                     </tr>
                                                                  ))
                                                               ) : (
                                                                  <tr>
                                                                     <td colSpan="6" className="text-center text-muted py-4">
                                                                        No rental data available
                                                                     </td>
                                                                  </tr>
                                                               )}
                                                            </tbody>
                                                         </table>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                             <div className="tab-pane" id="tabItem4">
                                                <div className="row align-items-center justify-content-between">
                                                   <div className="col-md-6">
                                                      <h5>Most Rented Styles Report</h5>
                                                   </div>
                                                </div>
                                                <div className="row mt-3">
                                                   <div className="col-md-12">
                                                      <div className="table-responsive">
                                                         <table className="table table-striped">
                                                            <thead>
                                                               <tr>
                                                                  <th scope="col">Style Name</th>
                                                                  <th scope="col">Category</th>
                                                                  <th scope="col">Times Rented (YTD)</th>
                                                                  <th scope="col">Popularity Heat</th>
                                                               </tr>
                                                            </thead>
                                                            <tbody>
                                                               {inventoryRatings && inventoryRatings.length > 0 ? (
                                                                  inventoryRatings.map((item, index) => {
                                                                     const ratingNumber = parseInt(item.rating?.replace('inventory_rating_', '') || '0');
                                                                     const getFireClass = () => {
                                                                        if (ratingNumber >= 5) return 'brightred';
                                                                        if (ratingNumber >= 3) return 'ornageHot';
                                                                        return 'yellowHot';
                                                                     };
                                                                     return (
                                                                        <tr key={item.id || index}>
                                                                           <th scope="row">{item.style || 'N/A'} {item.description || 'N/A'}</th>
                                                                           <td>{item.category?.name || 'N/A'}</td>
                                                                           <td>{item.count || '0'}</td>
                                                                           <td className="fireIconGap">
                                                                              {ratingNumber > 0 ? (
                                                                                 [...Array(ratingNumber)].map((_, i) => (
                                                                                    <span key={i} className={getFireClass()}>
                                                                                       <i className="fa-solid fa-fire"></i>
                                                                                    </span>
                                                                                 ))
                                                                              ) : (
                                                                                 <span className="text-muted">No rating</span>
                                                                              )}
                                                                           </td>
                                                                        </tr>
                                                                     );
                                                                  })
                                                               ) : (
                                                                  <tr>
                                                                     <td colSpan="4" className="text-center text-muted py-4">
                                                                        Most Rented Style Report not available
                                                                     </td>
                                                                  </tr>
                                                               )}
                                                            </tbody>
                                                         </table>
                                                         {inventoryRatings.length > 0 && (
                                                            <div className="nk-block-between-md g-3 mt-3">
                                                               <div className="g">
                                                                  <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                                     <button
                                                                        className={`btn btn - sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'} `}
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                        disabled={currentPage === 1}
                                                                     >
                                                                        Previous
                                                                     </button>
                                                                     {Array.from({ length: totalPages }, (_, i) => (
                                                                        <button
                                                                           key={i + 1}
                                                                           className={`btn btn - sm ${currentPage == i + 1 ? 'btn-primary' : 'btn-outline-primary'} `}
                                                                           onClick={() => handlePageChange(i + 1)}
                                                                        >
                                                                           {i + 1}
                                                                        </button>
                                                                     )).slice(
                                                                        Math.max(0, currentPage - 3),
                                                                        Math.min(currentPage + 2, totalPages)
                                                                     )}
                                                                     <button
                                                                        className={`btn btn - sm ${currentPage === totalPages ? 'btn-disabled' : 'btn-primary'} `}
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                        disabled={currentPage === totalPages}
                                                                     >
                                                                        Next
                                                                     </button>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         )}
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </>}
                  </div>
               </div>
            </div>

         </Container >
      </>
   )
}

export default Dashboard;